module.exports = __webpack_public_path__ + "static/aprofile-38e6d5ce93599b6068e8ff33c1e816a8.png";